<template>

  <div 
    v-bind:id="'jt-form-div-' +formInputParameter.key"
    v-if="formInputValid" 
    v-show="formInputVisible()" 
    class="form-group" 
    v-bind="formInputParameter.form_container_attr || { 'class': 'col-12' }">

    <!-- section -->
    <h3 
      v-if="formInputParameter.form_section" 
      v-bind="formInputParameter.form_section_attr"
      v-html="formInputParameter.form_section" />
    <hr v-if="formInputParameter.form_section" />

    <!-- div -->
    <div 
      v-else-if="formInputParameter.form_div"
      v-bind="formInputParameter.form_div_attr" />

    <!-- custom html -->
    <div 
      v-else-if="formInputParameter.form_html"
      v-bind="formInputParameter.form_html_attr"
      v-html="formInputParameter.form_html(formInputParameter, formData)" />

    <!-- custom component -->
    <component 
      v-else-if="formInputParameter.form_component" 
      ref="input" 
      v-bind:is="formInputParameter.form_component"
      v-bind:formCanEdit="formCanEdit"
      v-bind:formIsAdd="formIsAdd" 
      v-bind:formInputParameter="formInputParameter"
      v-bind:formData="formData"
      v-on:input="onInput"
      v-on:change="onChange" />

    <!-- checkbox -->
    <div 
      v-else-if="formInputParameter.form_checkbox" >
      <input
        v-bind:id="'jt-form-input-' +formInputParameter.key"
        v-bind:name="'jt-form-input-' +formInputParameter.key"
        type="checkbox"
        v-bind:true-value="formInputParameter.form_checkbox.true_value || 1"
        v-bind:false-value="formInputParameter.form_checkbox.false_value || 0"
        ref="input" 
        v-bind="formInputAttr()"
        v-on:input="onInput"
        v-on:change="onChange"
        v-model="formData[formInputParameter.key]" >
      <label
        v-bind:for="'jt-form-input-' +formInputParameter.key"
        class="column-p-lbl"
        v-bind="formInputParameter.form_label_attr"
        v-html="formInputParameter.form_label || formInputParameter.text || formInputParameter.key">
      </label>
    </div>

    <!-- other input type -->
    <div v-else>

      <label
        v-bind="formInputParameter.form_label_attr"
        v-html="formInputParameter.form_label || formInputParameter.text || formInputParameter.key">
      </label>

      <!-- select -->
      <select 
        v-bind:id="'jt-form-input-' +formInputParameter.key"
        v-bind:name="'jt-form-input-' +formInputParameter.key"
        v-if="formInputParameter.form_select"
        class="form-control" 
        ref="input" 
        v-bind="formInputAttr()"
        v-on:input="onInput"
        v-on:change="onChange"
        v-model="formData[formInputParameter.key]" >
        <option
          v-for="selectOption in getFormSelectOption(formInputParameter)"
          v-bind:key="getFormSelectOptionValue(formInputParameter, selectOption)"
          v-bind:value="getFormSelectOptionValue(formInputParameter, selectOption)"
          v-bind="getFormSelectOptionAttr(formInputParameter, selectOption)"
          v-html="getFormSelectOptionText(formInputParameter, selectOption)">
        </option>
      </select>
      
      <!-- radio button -->
      <div
        v-bind:id="'jt-form-input-' +formInputParameter.key"
        v-else-if="formInputParameter.form_radio">
        <div 
          v-for="radioOption in getFormRadioOption(formInputParameter)"
          v-bind:key="getFormRadioOptionValue(formInputParameter, radioOption)"
          v-bind="getFormRadioOptionAttr(formInputParameter, radioOption)" >
          <input 
            v-bind:id="`jt-form-input-${formInputParameter.key}-${getFormRadioOptionValue(formInputParameter, radioOption)}`"
            type="radio" 
            v-bind:name="'jt-form-input-' +formInputParameter.key"
            v-bind:value="getFormRadioOptionValue(formInputParameter, radioOption)"
            v-bind="formInputAttr(formInputParameter, radioOption)"
            v-on:input="onInput"
            v-on:change="onChange"
            v-model="formData[formInputParameter.key]">
          <label
            v-bind:for="`jt-form-input-${formInputParameter.key}-${getFormRadioOptionValue(formInputParameter, radioOption)}`"
            class="column-p-lbl"
            v-html="getFormRadioOptionText(formInputParameter, radioOption)">
          </label>
          <span 
            v-if="radioOption.form_muted"
            class="help-block text-muted">
            <small v-html="formInputMutedText(radioOption)"></small>
          </span>
        </div>
      </div>

      <!-- summernote -->
      <div 
        v-bind:id="'jt-form-input-' +formInputParameter.key"
        v-else-if="formInputParameter.form_summernote"
        class="form-control" 
        ref="input" 
        v-bind="formInputAttr()"
        v-on:input="onInput"
        v-on:change="onChange">
        {{ formData[formInputParameter.key] }}
      </div>

      <!-- textarea -->
      <textarea 
        v-bind:id="'jt-form-input-' +formInputParameter.key"
        v-else-if="formInputParameter.form_textarea"
        class="form-control" 
        ref="input" 
        v-bind="formInputAttr()"
        v-on:input="onInput"
        v-on:change="onChange"
        v-model="formData[formInputParameter.key]" />

      <!-- input phone -->
      <div 
        v-else-if="formInputParameter.form_phone"
        class="input-group">
        <input 
          v-bind:id="'jt-form-input-' +formInputParameter.key"
          v-bind:name="'jt-form-input-' +formInputParameter.key"
          v-bind:data-key="formInputParameter.key"
          class="form-control" 
          ref="input" 
          type="phone"
          v-bind="formInputAttr()"
          v-on:input="onInput"
          v-on:change="onChange"
          v-model="formData[formInputParameter.key]" />
        <div class="input-group-append">
          <span class="input-group-text">
            <i class="fa fa-phone"></i>
          </span>
        </div>
      </div>

      <!-- input email -->
      <div 
        v-else-if="formInputParameter.form_email"
        class="input-group">
        <input 
          v-bind:id="'jt-form-input-' +formInputParameter.key"
          v-bind:name="'jt-form-input-' +formInputParameter.key"
          v-bind:data-key="formInputParameter.key"
          class="form-control" 
          ref="input" 
          type="email"
          v-bind="formInputAttr()"
          v-on:input="onInput"
          v-on:change="onChange"
          v-model="formData[formInputParameter.key]" />
        <div class="input-group-append">
          <span class="input-group-text">
            <i class="fa fa-envelope-o"></i>
          </span>
        </div>
      </div>

      <!-- input clockpicker -->
      <div 
        v-else-if="formInputParameter.form_clockpicker"
        class="input-group">
        <input 
          v-bind:id="'jt-form-input-' +formInputParameter.key"
          v-bind:name="'jt-form-input-' +formInputParameter.key"
          v-bind:data-key="formInputParameter.key"
          class="form-control myclockpicker" 
          ref="input" 
          v-bind="formInputAttr()"
          v-on:input="onInput"
          v-on:change="onChange"
          v-model="formData[formInputParameter.key]" />
        <div class="input-group-append">
          <span class="input-group-text">
            <i class="fa fa-clock-o"></i>
          </span>
        </div>
      </div>

      <!-- input datepicker -->
      <div 
        v-else-if="formInputParameter.form_datepicker"
        class="input-group">
        <input 
          v-bind:id="'jt-form-input-' +formInputParameter.key"
          v-bind:name="'jt-form-input-' +formInputParameter.key"
          v-bind:data-key="formInputParameter.key"
          class="form-control mydatepicker" 
          ref="input" 
          v-bind="formInputAttr()"
          readonly="readonly"
          v-on:input="onInput"
          v-on:change="onChange"
          v-model="formData[formInputParameter.key]"
          autocomplete="off" />
        <div class="input-group-append">
          <span class="input-group-text">
            <i class="fa fa-calendar-o"></i>
          </span>
        </div>
      </div>

      <!-- input hidden + dropzone -->
      <div 
        v-else-if="formInputParameter.form_dropzone">
        <div v-html="getFileCell(formInputParameter, formData)" />
        <input 
          v-bind:id="'jt-form-input-' +formInputParameter.key"
          v-bind:name="'jt-form-input-' +formInputParameter.key"
          v-bind:data-key="formInputParameter.key"
          class="form-control" 
          ref="input" 
          type="hidden"
          v-bind="formInputAttr()"
          v-on:input="onInput"
          v-on:change="onChange"
          v-model="formData[formInputParameter.key]" />
        <div
          v-bind:id="'jt-form-dropzone-' +formInputParameter.key"
          v-show="!formInputAttr().disabled"
          class="dropzone"
          action="#" >
        </div>
      </div>

      <!-- form file -->
      <input 
        v-bind:id="'jt-form-input-' +formInputParameter.key"
        v-bind:name="'jt-form-input-' +formInputParameter.key"
        v-else-if="formInputParameter.form_file"
        v-bind:data-key="formInputParameter.key"
        type="file"
        class="form-control" 
        ref="input" 
        v-bind="formInputAttr()"
        v-on:input="onInput"
        v-on:change="onChange" />

      <!-- input tag -->
      <vue-tags-input
        v-bind:id="'jt-form-input-' +formInputParameter.key"
        v-bind:name="'jt-form-input-' +formInputParameter.key"
        v-else-if="formInputParameter.form_tag_input"
        v-model="formData[formInputParameter.key + '_value']"
        :tags="formData[formInputParameter.key]"
        @tags-changed="newTags => tags = newTags"
      />

      <!-- input normal - can bind any attribute, just no input-group styling and built-in validation -->
      <input 
        v-bind:id="'jt-form-input-' +formInputParameter.key"
        v-bind:name="'jt-form-input-' +formInputParameter.key"
        v-else
        v-bind:data-key="formInputParameter.key"
        class="form-control" 
        ref="input" 
        v-bind="formInputAttr()"
        v-on:input="onInput"
        v-on:change="onChange"
        v-model="formData[formInputParameter.key]" />
      
    </div>

    <slot />

    <span 
      class="help-block text-muted">
      <small v-html="formInputMutedText(formInputParameter)"></small>
    </span>

    <label 
      class="error form-control-feedback"
      v-show="inputError" 
      v-bind:class="formInputParameter.form_error_class">
      {{ inputError }}
    </label>

  </div>

</template>

<script>
import helper from "@/components/Utility/Helper"
import VueTagsInput from '@johmun/vue-tags-input';

var moment = require('moment');

export default {
name: "AppFormInput",
props: ['formIsAdd', 'formInputParameter', 'formData'],
components: {
  VueTagsInput,
},
data () {
  return {
    inputDropzone: null,
    inputError: null,
    formCanEdit: null,
    tags: [],
  }
},
computed: {
  formInputValid: function () {
    if(this.formInputParameter.index || this.formInputParameter.id || this.formInputParameter.form_invalid) {
      return false;
    }
    return true
  },
},
mounted() {
  if(this.formInputParameter.form_dropzone) {
    var self = this;
    var header = {};
    helper.addTokenToHeader(header);

    try {
      // TODO kw currently hardcoded to upload image to specific url, make it generic!
      this.inputDropzone = new Dropzone('#jt-form-dropzone-' + self.formInputParameter.key, {
        url: helper.API_URL + '/api2/images/upload',
        headers: header,
        key: self.formInputParameter.key,
        paramName : "imgUploader", // The name that will be used to transfer the file
        maxFilesize : 10, // MB
        maxFiles : 1,
        addRemoveLinks : true,
        thumbnail: function(file) {
          if(self.formInputParameter.form_dropzone_height) {
            if(file.height !== self.formInputParameter.form_dropzone_height) {
              self.inputDropzone.removeAllFiles(true);
              self.setInputError('Problem uploading file. Image height should be ' + self.formInputParameter.form_dropzone_height);
              return false;
              // file.rejectDimensions()
            }
          }
          if(self.formInputParameter.form_dropzone_width) {
            if(file.width !== self.formInputParameter.form_dropzone_width) {
              self.inputDropzone.removeAllFiles(true);
              self.setInputError('Problem uploading file. Image width should be ' + self.formInputParameter.form_dropzone_width);
              return false;
              // file.rejectDimensions()
            }
          }
          
          self.setInputError();
          // file.acceptDimensions();
        },
        error: function(file, errorMessage, xhr) {
          if(typeof errorMessage === 'object') {
            errorMessage = errorMessage.message || errorMessage.error;
          }
          $(file.previewElement).addClass("dz-error").find('.dz-error-message').text(errorMessage);
          self.setInputError('Problem uploading file. ' + errorMessage);
        },
        success : function(file, responseText, e) {
          if(!self.formData[self.formInputParameter.key + '_dropzone_original']) {
            self.formData[self.formInputParameter.key + '_dropzone_original'] = self.formData[self.formInputParameter.key];
          }
          try {
            responseText = JSON.parse(responseText)
          } catch(e) {
          }
          if(responseText.path) {
            responseText = responseText.path
          }
          var input_id = '#' + this.element.id.replace('dropzone', 'input');
          $(input_id).val(responseText);
          self.formData[self.formInputParameter.key] = responseText;
          self.setInputError();
        },
        reset : function() {
          var input_id = '#' + this.element.id.replace('dropzone', 'input');
          if(!self.formIsAdd) {
            $(input_id).val(self.formData[self.formInputParameter.key + '_dropzone_original']);
            self.formData[self.formInputParameter.key] = self.formData[self.formInputParameter.key + '_dropzone_original'];
            delete self.formData[self.formInputParameter.key + '_dropzone_original'];
          } else {
            $(input_id).val('');
            self.formData[self.formInputParameter.key] = null;
          }
          self.setInputError();
        }
      });
    } catch(e) {
      console.log('exception: ', e);
    }
  } else if(this.formInputParameter.form_clockpicker) {
    var self = this;

    try {
      $('#jt-form-input-' + self.formInputParameter.key).clockpicker({
        donetext : 'Done',
        afterDone: function(e) {
          self.formData[this.key] = e.input[0].value;
          self.onInput();
          self.onChange();
        },
      })
    } catch (e) {
    }
  } else if(this.formInputParameter.form_datepicker) {
    var self = this;

    try {
      $('#jt-form-input-' + self.formInputParameter.key).datepicker({
        todayHighlight : true,
        // format : helper.DEFAULT_DATE_FORMAT,
        format: {
          toDisplay: function (date, format, language) {
            return helper.formatDate(date);
          },
          toValue: function (date, format, language) {
            return date;
          },
        },
        beforeShowDay: this.formInputParameter.form_datepicker.beforeShowDay
      })
      .on('changeDate', function(e) {
        let key = $(e.target).data('key');
        let temp = String(self.formData[key] = $(e.target).val());
        self.onInput();
        self.onChange();
      })
      .on('hide', function(e) {
        $('#jt-form-input-' + self.formInputParameter.key).datepicker('update', moment(self.formData[self.formInputParameter.key], helper.DEFAULT_DATE_FORMAT).toDate());
      })
    } catch (e) {
    }
  } else if(this.formInputParameter.form_chosen) {
    var self = this;

    try {
      $('#jt-form-input-' + self.formInputParameter.key).chosen();
      $(('#jt-form-input-' + self.formInputParameter.key).replace(/-/g, '_') + '_chosen').css('width', '100%');
      $('#jt-form-input-' + self.formInputParameter.key).on('change', (evt, params) => {
        if(params) {
          history.replaceState({}, document.title, helper.updateQueryString(window.location.href, this.formInputParameter.key, params.selected));

          self.formData[self.formInputParameter.key] = params.selected;
          self.onInput();
          self.onChange();
        } else {
          history.replaceState({}, document.title, helper.updateQueryString(window.location.href, this.formInputParameter.key, ''));
        }
      });
    } catch (e) {
    }
  } else if(this.formInputParameter.form_chosen_multiple) {
    var self = this;

    try {
      $('#jt-form-input-' + self.formInputParameter.key).chosen();
      $(('#jt-form-input-' + self.formInputParameter.key).replace(/-/g, '_') + '_chosen').css('width', '100%');
      $('#jt-form-input-' + self.formInputParameter.key).on('change', (evt, params) => {
        if(params) {
          if(params.selected) {
            self.formData[self.formInputParameter.key].push(params.selected);
            self.onInput();
            self.onChange();
          } else if(params.deselected) {
            var index = self.formData[self.formInputParameter.key].indexOf(params.deselected);
            if (index > -1) {
              self.formData[self.formInputParameter.key].splice(index, 1);
            }
            self.onInput();
            self.onChange();
          }
        }
      });
    } catch (e) {
    }
  } else if(this.formInputParameter.form_checkbox) {
    var self = this;

    try {
      $('#jt-form-input-' + self.formInputParameter.key).iCheck({
        checkboxClass: 'icheckbox_square-green',
        radioClass: 'iradio_square-green'
      }).on('ifChanged', function(e) {
        $(e.target).trigger('change');//.change();
        self.onInput();
        self.onChange();
        self.formData[self.formInputParameter.key] = $(e.target).is(':checked') ? 1 : 0;
        $(e.target).iCheck('update');
      });
    } catch (e) {
    }
  } else if(this.formInputParameter.form_radio) {
    var self = this;

    try {
      $('#jt-form-input-' + self.formInputParameter.key).iCheck({
        checkboxClass: 'icheckbox_square-green',
        radioClass: 'iradio_square-green'
      }).on('ifChanged', function(e) {
        $(e.target).trigger('change');//.change();
        self.onInput();
        self.onChange();
        // TODO last click radio button = selected?
        self.formData[self.formInputParameter.key] = $(e.target).val();
      });
    } catch (e) {
    }
  } else if(this.formInputParameter.form_summernote) {
    var self = this;
    $('#jt-form-input-' + this.formInputParameter.key).summernote({
      minHeight: '300px',
      callbacks: {
        onChange: function(contents, $editable) {
          self.formData[self.formInputParameter.key] = contents;
          self.onInput();
          self.onChange();
        }
      }
    });
  }
},
updated: function () {
  if(this.formInputParameter.form_chosen || this.formInputParameter.form_chosen_multiple) {
    this.$nextTick(function () {
      $('#jt-form-input-' + this.formInputParameter.key).trigger("chosen:updated");
    })
  } else if(this.formInputParameter.form_datepicker) {
    // $('#jt-form-input-' + this.formInputParameter.key).datepicker("update", this.formData[this.formInputParameter.key]);
  } else if(this.formInputParameter.form_checkbox || this.formInputParameter.form_radio) {
    $('#jt-form-input-' + this.formInputParameter.key).iCheck('update');
  } else if(this.formInputParameter.form_summernote) {
    $('#jt-form-input-' + this.formInputParameter.key).summernote('code', this.formData[this.formInputParameter.key]);
  }
},
methods: {
  formInputVisible: function () {
    return !(this.formInputParameter.form_hide || (this.formIsAdd ? this.formInputParameter.form_add_hide : this.formInputParameter.form_edit_hide))
  },
  formInputAttr: function(formInputParameter, radioOption) {
    let commontAttr = {};
    if(this.formInputParameter.form_input_attr) {
      if(typeof this.formInputParameter.form_input_attr === 'function') {
        commontAttr = this.formInputParameter.form_input_attr(formInputParameter, radioOption)
      } else {
        commontAttr = this.formInputParameter.form_input_attr
      }
    }
    let specialAttr = {};

    if(this.formIsAdd) {
      if(this.formInputParameter.form_add_input_attr) {
        if(typeof this.formInputParameter.form_add_input_attr === 'function') {
          specialAttr = this.formInputParameter.form_add_input_attr(formInputParameter, radioOption)
        } else {
          specialAttr = this.formInputParameter.form_add_input_attr
        }
      }
    } else {
      if(this.formInputParameter.form_edit_input_attr) {
        if(typeof this.formInputParameter.form_edit_input_attr === 'function') {
          specialAttr = this.formInputParameter.form_edit_input_attr(formInputParameter, radioOption)
        } else {
          specialAttr = this.formInputParameter.form_edit_input_attr
        }
      }
    }

    let allAttr = Object.assign({}, commontAttr, specialAttr);

    if(!this.formCanEdit) {
      allAttr['disabled'] = 1;
    }
    return allAttr;
  },
  formInputMutedText: function (formInputParameter) {
    let formMuted = (this.formIsAdd ? formInputParameter.form_add_muted : formInputParameter.form_edit_muted) || formInputParameter.form_muted;
    if(typeof formMuted === 'function') {
      return formMuted(this);
    } else {
      return formMuted;
    }
  },

  onInput() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.$emit('form-input', this.formInputParameter, this.formData[this.formInputParameter.key]);
      });
    }, 100)
  },
  onChange() {
    if(this.formInputParameter.form_file) {
      this.formData[this.formInputParameter.key] = this.$refs['input'].files;
    }
    this.$nextTick(() => {
      this.$emit('form-change', this.formInputParameter, this.formData[this.formInputParameter.key]);
    });
  },

  setInputError(inputError, dontScrollToInput) {
    this.inputError = inputError;

    if(!inputError || dontScrollToInput) {
      return;
    }

    try {
      let div = $('#jt-form-div-' + this.formInputParameter.key);
      // sometime will get closest not available without console.log inbetween
      let modal = div.closest('.modal');
      // let modal = $('#jt-form-div-' + this.formInputParameter.key).closest('.modal');
      ((modal && modal.length > 0) ? modal : $(document)).scrollTop(div[0].offsetTop);
    } catch(e) {
    }
  },
  setInputReset() {
    this.inputError = null;
    if(this.inputDropzone) {
      this.inputDropzone.removeAllFiles(true);
    }
  },
  setFormCanEdit(formCanEdit) {
    this.formCanEdit = formCanEdit;
  },

  getFormSelectOption(formInputParameter) {
    let temp = (formInputParameter.form_select.data || formInputParameter.form_select || []).slice();
    if(formInputParameter.form_select_sort && typeof formInputParameter.form_select_sort === 'function') {
      formInputParameter.form_select_sort(temp);
    } else {
      if(temp && temp[temp.length - 1] && temp[temp.length - 1]['createDate']) {
        temp.sort((a, b) => b.createDate - a.createDate);
      }
    }
    if(window.location.href.includes('localhost')) {
      if(formInputParameter.key === 'carparkID') {
        // temp = temp.filter(k => k.name.toUpperCase().startsWith('KW'));
      }
    }
    return temp;
  },
  getFormSelectOptionValue(formInputParameter, selectOption) {
    return this.getFormSelectOrRadioValue(formInputParameter, 'form_select', selectOption, 'formatSelectOptionValue');
  },
  getFormSelectOptionAttr(formInputParameter, selectOption) {
    if(formInputParameter.form_select.formatSelectOptionAttr) {
      if(typeof formInputParameter.form_select.formatSelectOptionAttr === 'function') {
        return formInputParameter.form_select.formatSelectOptionAttr(selectOption);
      } else {
        return formInputParameter.form_select.formatSelectOptionAttr;
      }
    }
    return null;
  },
  getFormSelectOptionText(formInputParameter, selectOption) {
    return this.getFormSelectOrRadioText(formInputParameter, 'form_select', selectOption, 'formatSelectOptionText', 'formatSelectOptionValue');
  },

  getFormRadioOption(formInputParameter) {
    return formInputParameter.form_radio.data || formInputParameter.form_radio;
  },
  getFormRadioOptionValue(formInputParameter, radioOption) {
    return this.getFormSelectOrRadioValue(formInputParameter, 'form_radio', radioOption, 'formatRadioOptionValue');
  },
  getFormRadioOptionAttr(formInputParameter, radioOption) {
    if(formInputParameter.form_radio.formatRadioOptionAttr) {
      if(typeof formInputParameter.form_radio.formatRadioOptionAttr === 'function') {
        return formInputParameter.form_radio.formatRadioOptionAttr(radioOption);
      } else {
        return formInputParameter.form_radio.formatRadioOptionAttr;
      }
    }
    return null;
  },
  getFormRadioOptionText(formInputParameter, radioOption) {
    return this.getFormSelectOrRadioText(formInputParameter, 'form_radio', radioOption, 'formatRadioOptionText', 'formatRadioOptionValue');
  },

  getFormSelectOrRadioValue(formInputParameter, formAttribute, option, formatValueFunction) {
    // form_select: {data: [{1},{2},...], formatSelectOptionValue: f, formatSelectOptionText: f}
    if(formInputParameter[formAttribute].data) {
      if(typeof formInputParameter[formAttribute][formatValueFunction] === "function") {
        return formInputParameter[formAttribute][formatValueFunction](option);
      }
    }

    // form_select: {data: [{value:text},{value:text},...]}
    // form_select: [{value:text},{value:text},...]
    if(option instanceof Object) {
      if(option.id !== null && option.id !== undefined) {
        return option.id;
      }

      return Object.keys(option)[0];
    }

    // form_select: [1,2,...]
    // form_select: {data: [1,2,...]}
    return option;
  },
  getFormSelectOrRadioText(formInputParameter, formAttribute, option, formatTextFunction, formatValueFunction) {
    if(formInputParameter[formAttribute].data) {
      if(typeof formInputParameter[formAttribute][formatTextFunction] === "function") {
        return formInputParameter[formAttribute][formatTextFunction](option);
      }
      if(typeof formInputParameter[formAttribute][formatValueFunction] === "function") {
        return formInputParameter[formAttribute][formatValueFunction](option);
      }
    }

    if(option instanceof Object) {
      if(option.name !== null && option.name !== undefined) {
        return option.name;
      }

      if(option.id !== null && option.id !== undefined) {
        return option.id;
      }

      return option[Object.keys(option)[0]];
    }

    return option;
  },

  getFileCell(formInputParameter, formData) {
    if(!formData) {
      return;
    }

    let value = formData[formInputParameter.key];
    let width = formInputParameter.width ? formInputParameter.width : '40%';

    // TODO kw form file HTML tag
    if(value && value.startsWith('http')) {
      return `<img 
              src="${value}" 
              width="${width}"
              />`;
      // v-bind:alt="data[dataIndex][parameter[parameterIndex].key]"
    }

    return value;
  }
}
};
</script>


// WEBPACK FOOTER //
// src/components/App/AppFormInput.vue